import { doc, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../../../../firebase';

/**
 * Client-side early-out check and fire-and-forget trigger for the PAD
 * completion (assessment complete) email.
 *
 * Called from both the adult ADHD PAD review exit (RD_PAD.js) and the
 * CYP ADHD PAD review exit (CypAdhdReviewDocument.js). The server-side
 * callable (`sendPADCompletionEmail`) handles pathway branching (separate
 * org config key, dedup stamp, and non-pharm section skip for CYP).
 *
 * Adult patients use the `nonPharmOptionsEmailSent` stamp; CYP patients
 * use `cypPadCompletionEmailSent`. We check both for the same reason as
 * the SSI trigger: a CYP patient never has the adult stamp and vice
 * versa, so checking both is safe and avoids needing to determine the
 * pathway client-side.
 *
 * @param {string} patientId - The patient's user ID
 * @param {string} clinicianId - The clinician's user ID
 */
export const TriggerPADCompletionEmail = async (patientId, clinicianId) => {
    if (!patientId) return;

    try {
        console.log(`[NotificationFunctions] Checking PAD completion email for patient: ${patientId}`);

        // Get patient data with a single Firestore read
        const patientDoc = await getDoc(doc(db, 'patients', patientId));
        if (!patientDoc.exists()) return;

        const patientData = patientDoc.data();

        // Skip if notification already sent (check both adult and CYP stamps)
        if (patientData.nonPharmOptionsEmailSent || patientData.cypPadCompletionEmailSent) {
            console.log('Notification already sent for PAD completion email');
            return;
        }
        
        console.log('Triggering notification...');
        // Fire and forget - don't await this call
        httpsCallable(functions, 'sendPADCompletionEmail')({ patientId, clinicianId })
            .then(() => console.log('PAD completion email sent'))
            .catch(err => console.error('Error sending PAD completion email:', err));

    } catch (error) {
        console.error('Error checking PAD completion email:', error);
    }
};